import * as types from './constants';

// Invite Member
export const inviteMemberRequest = data => (
  { type: types.INVITE_MEMBER_REQUEST, payload: data }
);

export const inviteMemberDone = data => (
  { type: types.INVITE_MEMBER_DONE, payload: data }
);

export const inviteMemberFailed = errors => (
  { type: types.INVITE_MEMBER_FAILED, payload: errors }
);